// Intercettore globale: gestisce 401 (sessione scaduta) e 403 PASSWORD_CHANGE_REQUIRED (SEC-001)
const originalFetch = window.fetch;

window.fetch = async (...args) => {
  const res = await originalFetch(...args);
  try {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const isApi = url.includes('/api/');
    const isPublicAuth = url.includes('/api/auth/login') || url.includes('/api/auth/forgot-password') || url.includes('/api/auth/reset-password');
    if (isApi && !isPublicAuth) {
      if (res.status === 401 && localStorage.getItem('token')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (window.location.pathname !== '/login') window.location.replace('/login');
      } else if (res.status === 403) {
        const text = await res.clone().text().catch(() => '');
        if (text.includes('PASSWORD_CHANGE_REQUIRED')) {
          const raw = localStorage.getItem('user');
          if (raw) {
            const u = JSON.parse(raw);
            if (!u.first_login) {
              u.first_login = true;
              localStorage.setItem('user', JSON.stringify(u));
              window.location.replace('/');
            }
          }
        }
      }
    }
  } catch (e) { console.debug('fetchInterceptor:', e); /* mai bloccare la response */ }
  return res;
};
